import { memo, useEffect, useState } from "react";
import { KeyConstant, LangConstant, SystemConstant } from "const";
import { useCleanUpEffect } from "hooks";
import { convertString2JSON, StorageUtil, toCamel } from "utils";
import { useConversationContext } from "../ConversationContext";
import { getInteractor } from "services/local.service";
import { getNSLang } from "utils/lang.utils";
import LineChat from "../LineChat";

const AddGroupMessage = ({ message }) => {
  const prefixKey = StorageUtil.getCurrentPrefixKey();
  const branchId = StorageUtil.getItem(KeyConstant.KEY_BRANCH_ID, prefixKey);
  const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID, prefixKey);

  const { isMounted } = useCleanUpEffect();

  const { groupDetail } = useConversationContext();
  const isChannel = groupDetail.groupType === SystemConstant.GROUP_CHAT_TYPE.channel;

  const [content, setContent] = useState("");

  const handleMessageContent = async message => {
    const contentObj = message.content ? convertString2JSON(message.content, {}) : {};
    const { member_id } = contentObj;

    if (message.senderId && member_id) {
      const senderAccount = await getInteractor(prefixKey).LocalAccountService.get(message.senderId, branchId);
      const addAccount = await getInteractor(prefixKey).LocalAccountService.get(member_id, branchId);

      const displayContent = getNSLang(
        LangConstant.NS_HOME,
        isChannel ? "FM_ADD_MEMBER_CHANNEL" : "FM_ADD_MEMBER_GROUP",
        {
          senderName: message.senderId === accountId ? "Bạn" : senderAccount?.name,
          addMemberName: member_id === accountId ? "bạn" : addAccount?.name,
        },
      );

      if (isMounted()) setContent(displayContent);
    }
  };

  useEffect(() => {
    if (message && message.id) handleMessageContent(toCamel(message));
  }, [message]);

  return <LineChat data={content} />;
};

export default memo(AddGroupMessage);
